import { render, staticRenderFns } from "./ExamStepTwo.vue?vue&type=template&id=db279ef4&scoped=true&"
import script from "./ExamStepTwo.vue?vue&type=script&lang=js&"
export * from "./ExamStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./ExamStepTwo.vue?vue&type=style&index=0&id=db279ef4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db279ef4",
  null
  
)

export default component.exports